// extracted by mini-css-extract-plugin
export default {"screen":"CallLog_screen__Y3wnn","container":"CallLog_container__ZybFh","label":"CallLog_label__LJXBU","sub_label":"CallLog_sub_label__Oxmnf"};